"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UICardHeader;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _classnames = _interopRequireDefault(require("classnames"));

var _sizes = require("HubStyleTokens/sizes");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UIAccordionItem = _interopRequireDefault(require("../accordion/UIAccordionItem"));

var _UICardSection = _interopRequireDefault(require("../card/UICardSection"));

var _AbstractTextElement = _interopRequireDefault(require("../elements/AbstractTextElement"));

var _UIFlex = _interopRequireDefault(require("../layout/UIFlex"));

var _tshirtSize = require("../utils/propTypes/tshirtSize");

var _omit = _interopRequireDefault(require("../utils/underscore/omit"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  flex: 1 0 auto;\n  text-align: right;\n  margin-left: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var headingForSize = {
  xs: 'span',
  sm: 'h5',
  md: 'h4',
  lg: 'h2',
  xl: 'h1'
};

var Toolbar = _styledComponents.default.div.withConfig({
  displayName: "UICardHeader__Toolbar",
  componentId: "b1f8jl-0"
})(_templateObject(), _sizes.BASE_SPACING_X);

function UICardHeader(props) {
  var className = props.className,
      expanded = props.expanded,
      onExpandedChange = props.onExpandedChange,
      title = props.title,
      titleSize = props.titleSize,
      toolbar = props.toolbar,
      other = (0, _objectWithoutProperties2.default)(props, ["className", "expanded", "onExpandedChange", "title", "titleSize", "toolbar"]);
  var isExpander = typeof onExpandedChange === 'function';
  var shorthandSize = (0, _tshirtSize.toShorthandSize)(titleSize);
  var renderedTitle = isExpander ? _react.default.createElement(_UIAccordionItem.default, {
    className: "private-card__title",
    flush: true,
    onOpenChange: onExpandedChange,
    open: expanded,
    title: title,
    size: shorthandSize
  }) : _react.default.createElement(_AbstractTextElement.default, {
    className: "private-card__title",
    tagName: headingForSize[shorthandSize]
  }, title);
  return _react.default.createElement(_UICardSection.default, (0, _extends2.default)({
    className: (0, _classnames.default)('private-card__header', className),
    isHeader: true
  }, other), _react.default.createElement(_UIFlex.default, {
    align: "start",
    justify: "between"
  }, renderedTitle, toolbar && expanded ? _react.default.createElement(Toolbar, {
    className: "private-card__toolbar private-card__title"
  }, toolbar) : null));
}

UICardHeader.propTypes = (0, _extends2.default)({}, (0, _omit.default)(_UICardSection.default.propTypes, ['children']), {
  expanded: _propTypes.default.bool.isRequired,
  onExpandedChange: _propTypes.default.func,
  title: _propTypes.default.node,
  titleSize: _tshirtSize.allSizes,
  toolbar: _propTypes.default.node
});
UICardHeader.defaultProps = {
  expanded: true,
  titleSize: 'md'
};
UICardHeader.displayName = 'UICardHeader';
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3722/js/card/UICardHeader.js
// module id = 817
// module chunks = 5 6